var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-form-model", {
    ref: "form",
    attrs: {
      layout: "inline",
      model: _vm.form,
      "label-col": {
        span: 8
      },
      "wrapper-col": {
        span: 16
      }
    }
  }, [_c("a-row", [_c("a-col", {
    attrs: {
      span: "8"
    }
  }, [_c("a-form-model-item", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      label: _vm.$t("审核状态"),
      prop: "status"
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("审核状态")
    },
    model: {
      value: _vm.form.status,
      callback: function ($$v) {
        _vm.$set(_vm.form, "status", $$v);
      },
      expression: "form.status"
    }
  }, _vm._l(_vm.statusOptions, function (item) {
    return _c("a-select-option", {
      key: item.value,
      attrs: {
        value: item.value
      }
    }, [_vm._v(" " + _vm._s(_vm.$t(item.label)) + " ")]);
  }), 1)], 1)], 1)], 1), _c("a-row", [_c("a-form-model-item", {
    staticStyle: {
      width: "100%",
      "margin-top": "15px"
    }
  }, [_c("a-button", {
    staticClass: "marginR15",
    attrs: {
      type: "primary",
      "html-type": "submit"
    },
    on: {
      click: _vm.onSearch
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("查询")) + " ")]), _c("a-button", {
    staticClass: "marginR15",
    attrs: {
      type: "edit"
    },
    on: {
      click: _vm.reset
    }
  }, [_vm._v(_vm._s(_vm.$t("重置")))])], 1)], 1)], 1), _c("a-table", {
    staticClass: "marginT20",
    attrs: {
      bordered: "",
      columns: _vm.columns,
      "data-source": _vm.tableData,
      pagination: _vm.pagination,
      rowKey: "id"
    },
    on: {
      change: _vm.handleStandardTableChange
    },
    scopedSlots: _vm._u([{
      key: "idx",
      fn: function (text, record, index) {
        return [_c("span", [_vm._v(_vm._s((_vm.pagination.current - 1) * _vm.pagination.pageSize + index + 1))])];
      }
    }, {
      key: "jobTitle",
      fn: function (text, record) {
        return [_c("span", [_vm._v(_vm._s(record.jobTitle || "-"))])];
      }
    }, {
      key: "mediaUrl",
      fn: function (text, record) {
        return [_c("span", [_vm._v(_vm._s(record.mediaUrl || "-"))])];
      }
    }, {
      key: "status",
      fn: function (text, record) {
        return [_c("span", [_vm._v(_vm._s(_vm.statusEnums[record.status] || "-"))])];
      }
    }, {
      key: "rejectReason",
      fn: function (text, record) {
        return [_c("span", [_vm._v(_vm._s(record.rejectReason || "-"))])];
      }
    }, {
      key: "action",
      fn: function (text, record) {
        return [_vm.isAuth("customer.workSceneAudit") ? _c("a-button", {
          attrs: {
            type: "primary"
          },
          on: {
            click: function ($event) {
              return _vm.handleExamine(record);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("审核")))]) : _vm._e()];
      }
    }])
  }, _vm._l(_vm.columns, function (item, i) {
    var _item$slots, _item$slots2, _item$slots3;
    return _c("span", {
      key: i,
      attrs: {
        slot: (_item$slots = item.slots) === null || _item$slots === void 0 ? void 0 : _item$slots.title
      },
      slot: (_item$slots2 = item.slots) === null || _item$slots2 === void 0 ? void 0 : _item$slots2.title
    }, [_vm._v(_vm._s(_vm.$t((_item$slots3 = item.slots) === null || _item$slots3 === void 0 ? void 0 : _item$slots3.title)))]);
  }), 0), _c("examineModel", {
    attrs: {
      id: _vm.sceneId,
      examineVisible: _vm.examineVisible
    },
    on: {
      "update:examineVisible": function ($event) {
        _vm.examineVisible = $event;
      },
      "update:examine-visible": function ($event) {
        _vm.examineVisible = $event;
      }
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };